import { useQuery } from '@tanstack/react-query';

import { queries } from '../common/api/queryKeys/queries';

import { useSupplierSubscriptionReleaseFlags } from './useSupplierSubscriptionReleaseFlags';

export const useSupplierSubscriptionPlanCatalog = (enabled: boolean, throwOnError: boolean) => {
    const releaseFlags = useSupplierSubscriptionReleaseFlags(enabled);
    return useQuery({
        ...queries.supplierSubscriptionPlans.list(releaseFlags),
        enabled: enabled && releaseFlags.earlySubscriptionSignup,
        throwOnError,
    });
};
